import { render, staticRenderFns } from "./new-mega-layout.vue?vue&type=template&id=16c0c8de"
import script from "./new-mega-layout.vue?vue&type=script&lang=js"
export * from "./new-mega-layout.vue?vue&type=script&lang=js"
import style0 from "./new-mega-layout.vue?vue&type=style&index=0&id=16c0c8de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports